import React from 'react';
import { indicator } from 'ordinal';

type Props = {
  number: number;
  title: string;
};

export default function BaseIndicatorNumber(props: Props) {
  const { number, title } = props;

  return (
    <span>
      {number}
      <sup>{indicator(number)}</sup> {title}
    </span>
  );
}
